import { styled } from '@mui/material';
import { useEffect } from 'react';

import { useAuth } from '@verantos-dev/core-auth';
import { Loading } from '@verantos-dev/shared-components';

const StyledLogoutPage = styled('div')({
  backgroundImage: "url('./images/verantos-background.png')",
  backgroundColor: '#035b7f',
  height: '100%',
});

export const LogoutPage = () => {
  const { logout } = useAuth();

  // Before logging out from EL checking if user has access to other application
  // if yes then logging out from that application first
  useEffect(() => {
    (async () => {
      sessionStorage.clear();
      localStorage.clear();
      // Clear all cookies
      const allCookies = document.cookie.split(';');
      for (let i = 0; i < allCookies.length; i++) {
        document.cookie = allCookies[i] + '=;expires=' + new Date(0).toUTCString();
      }
      await logout();
    })();
  });

  return (
    <StyledLogoutPage>
      <Loading />
    </StyledLogoutPage>
  );
};
